import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  Button,
  Col,
  DatePicker,
  Divider,
  Form,
  Input,
  Modal,
  Pagination,
  Radio,
  Row,
  Select,
  Table,
} from "antd";
import { Option } from "antd/es/mentions";
import moment from "moment";

import * as XLSX from "xlsx";

import promotionApi from "../../../apis/Promotion.api";
import pushApi from "../../../apis/Push.api";
import salesManageApi from "../../../apis/SalesManage.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import status from "../../../utils/status";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const CancelManageComponent = () => {
  const dispatch = useDispatch();

  const user = useSelector((state) => state.auth.user);
  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [cancelStatus, setCancelStatus] = useState({
    cancelRequest: 0,
    cancelComplete: 0,
  });
  const [dateType, setDateType] = useState("1week");
  const [searchOptions, setSearchOptions] = useState({
    searchType: "payment_created_at",
    searchStatus: "cancel_request",
    searchOrderId: "",
    searchProductName: "",
    funnel: 0,
    name: "",
    phone: "",
    startDate: moment().subtract(7, "days").startOf("day"),
    endDate: moment().endOf("day"),
  });
  const [orderType, setOrderType] = useState("payment_created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [selectedRowKey, setSelectedRowKey] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [totalSize, setTotalSize] = useState(0);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [deliveryCompanyList, setDeliveryCompanyList] = useState([]);
  const [totalOrderList, setTotalOrderList] = useState([]);
  const [orderList, setOrderList] = useState([]);
  const [isCancelRefusalModalOpen, setIsCancelRefusalModalOpen] =
    useState(false);
  const [cancelRefusalReason, setCancelRefusalReason] = useState({
    cancel_reason: "상품 배송중",
    cancel_reason_detail:
      "고객님, 취소요청하신 상품이 이미 발송되어, 상품 받으신 후에 반품 및 교환만 가능합니다.",
    delivery_company: null,
    tracking_number: "",
    ship_date: moment(),
  });
  const [error, setError] = useState("");

  const searchDateItems = [
    { searchText: "결제일", searchType: "payment_created_at" },
    { searchText: "클레임 요청일", searchType: "cancel_request_at" },
  ];
  const dateTypeItems = [
    { label: "오늘", value: "today" },
    { label: "1주일", value: "1week" },
    { label: "1개월", value: "1month" },
    { label: "3개월", value: "3month" },
    { label: "6개월", value: "6month" },
  ];
  const orderStatusItems = [
    { label: "전체", value: "total" },
    // {label: '입금대기', value: 'ready'},
    // {label: '입금완료', value: 'paid'},
    // {label: '결제실패', value: 'failed'},
    // {label: '결제취소', value: 'cancelled'},
    // {label: '배송준비중', value: 'delivery_ready'},
    // {label: '배송중', value: 'delivery_shipping'},
    // {label: '배송완료', value: 'delivery_complete'},
    // {label: '구매확정', value: 'complete'},
    { label: "취소요청", value: "cancel_request" },
    // {label: '교환요청', value: 'exchange_request'},
    // {label: '반품요청', value: 'return_request'},
    { label: "취소완료", value: "cancel_complete" },
    // {label: '교환완료', value: 'exchange_complete'},
    // {label: '반품완료', value: 'return_complete'}
  ];
  const funnelStatusItems = [
    { label: "전체", value: 0 },
    { label: "검색", value: 1 },
    { label: "전화주문", value: 4 },
    { label: "인플루언서", value: 2 },
    { label: "셀러", value: 5 },
    { label: "공동구매", value: 3 },
  ];
  const orderPair = {
    payment_created_at: "결제일순",
    order_id: "주문번호순",
    cancel_request_at: "클레임 요청일순",
  };
  const rowSelection = {
    selectedRowKeys: selectedRowKey,
    onSelect: (record, selected) => {
      let editKeyList = [];
      let editRowList = [];
      if (selected) {
        editRowList = totalOrderList.filter(
          (order) => order.order_id === record.order_id,
        );
        editKeyList = editRowList.map((row) => row.order_detail_id);
      } else {
        editRowList = [];
        editKeyList = [];
      }
      setSelectedRowKey(editKeyList);
      setSelectedRow(editRowList);
    },
  };
  const columns = [
    {
      title: "주문번호",
      width: 90,
      dataIndex: "order_id",
      key: "order_id",
      fixed: "left",
      ellipsis: true,
      sorter: (a, b) => {},
    },
    {
      title: "주문일시",
      width: 160,
      dataIndex: "created_at",
      key: "created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "상품명",
      width: 200,
      dataIndex: "product_name",
      key: "product_name",
      ellipsis: true,
    },
    {
      title: "옵션명",
      // width: 200,
      dataIndex: "option_title",
      key: "option_title",
      ellipsis: true,
    },
    {
      title: "구매자명",
      width: 90,
      dataIndex: "created_by_name",
      key: "created_by_name",
      ellipsis: true,
    },
    {
      title: "결제일",
      width: 160,
      dataIndex: "payment_created_at",
      key: "payment_created_at",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        }
      },
    },
    {
      title: "주문상태",
      width: 90,
      dataIndex: "order_detail_status",
      key: "order_detail_status",
      ellipsis: true,
      render: (value) => {
        return status.orderStatusChange(value);
      },
    },
    {
      title: "취소 처리상태",
      width: 110,
      dataIndex: "cancel_target",
      key: "cancel_target",
      ellipsis: true,
      render: (value, record) => {
        let returnStr = "";
        switch (value) {
          case "user":
            returnStr += "구매자 ";
            break;
          case "admin":
            returnStr += "관리자 ";
        }
        switch (record.order_detail_status) {
          case "cancel_request":
            returnStr += "취소요청";
            break;
          case "cancel_complete":
            returnStr += "취소완료";
            break;
        }
        return returnStr;
      },
    },
    {
      title: "취소요청일",
      width: 160,
      dataIndex: "cancel_request_date",
      key: "cancel_request_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        } else {
          return value;
        }
      },
    },
    {
      title: "취소사유",
      width: 110,
      dataIndex: "cancel_reason",
      key: "cancel_reason",
      ellipsis: true,
    },
    {
      title: "취소승인일",
      width: 160,
      dataIndex: "cancel_approval_date",
      key: "cancel_approval_date",
      ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value !== null) {
          const date = moment(value).format("YYYY.MM.DD. HH:mm");
          return date;
        } else {
          return value;
        }
      },
    },
  ];

  useEffect(() => {
    getOrderCancelStatus();
    getDeliveryCompanyList();
  }, []);

  useEffect(() => {
    setOrderList(totalOrderList.slice(offset, offset + pageSize));
  }, [offset, pageSize]);

  useEffect(() => {
    handleChangePagination(currentPageNumber);
  }, [pageSize]);

  useEffect(() => {
    getUserOrderList();
  }, [orderType, orderBy]);

  const getDeliveryCompanyList = async () => {
    setIsLoading(true);
    try {
      const res = await salesManageApi.deliveryCompanyList("delivery_tracker");
      if (res.code === 200) {
        setDeliveryCompanyList(res.result);
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getDeliveryCompanyList read error", error);
    }
  };

  /**
   * 주문취소 현황 가져오기
   */
  const getOrderCancelStatus = async () => {
    const param = {
      userId: user.id === 724 ? 1 : user.id,
    };
    const res = await salesManageApi.salesManageStatus(param);
    if (res.code === 200) {
      setCancelStatus({
        ...cancelStatus,
        cancelRequest: res.result.cancelRequestList?.length ?? 0,
        cancelComplete: res.result.cancelCompleteList?.length ?? 0,
        // cancelRequest:
        // 	res.result.cancelRequestCnt === null
        // 		? 0
        // 		: res.result.cancelRequestCnt,
        // cancelComplete:
        // 	res.result.cancelCompleteCnt === null
        // 		? 0
        // 		: res.result.cancelCompleteCnt,
      });
    }
  };

  console.log(searchOptions);
  const getUserOrderList = async (type = "") => {
    setIsLoading(true);
    try {
      let res;
      if (type === "initial") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "cancel",
          searchDateItems[0].searchType,
          moment().subtract(7, "days").startOf("day").format("YYYYMMDDHHmm"),
          moment().endOf("day").format("YYYYMMDDHHmm"),
          orderStatusItems[1].value,
          "",
          "",
          0,
          "",
          "",
          "payment_created_at",
          "desc",
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else if (type === "search") {
        res = await salesManageApi.searchOrderDetailList(
          0,
          10,
          "cancel",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      } else {
        res = await salesManageApi.searchOrderDetailList(
          offset,
          pageSize,
          "cancel",
          searchOptions.searchType,
          searchOptions.startDate.startOf("day").format("YYYYMMDDHHmm"),
          searchOptions.endDate.endOf("day").format("YYYYMMDDHHmm"),
          searchOptions.searchStatus,
          searchOptions.searchOrderId,
          searchOptions.searchProductName,
          searchOptions.funnel,
          searchOptions.name,
          searchOptions.phone.includes("-")
            ? searchOptions.phone.replaceAll("-", "")
            : searchOptions.phone,
          orderType,
          orderBy,
          "",
          "",
          user.id === 724 ? 1 : user.id,
        );
      }
      if (res.code === 200) {
        setTotalOrderList(res.result.userOrderDetailDTOList);
        if (type === "initial" || type === "search") {
          setOrderList(res.result.userOrderDetailDTOList.slice(0, 10));
        } else {
          setOrderList(
            res.result.userOrderDetailDTOList.slice(offset, offset + pageSize),
          );
        }
        if (res.result?.length !== 0) {
          setTotalSize(res.result.totalCnt);
        } else {
          setTotalSize(0);
        }
      } else {
        alert(
          "해당 정보를 가져오는데 실패했습니다. 다시 시도해주시기 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getUserOrderList read error", error);
    }
  };

  /**
   * handle dateType change
   */
  const handleDateTypeChange = (e) => {
    const value = e.target.value;
    setDateType(value);
    switch (value) {
      case "today":
        setSearchOptions({
          ...searchOptions,
          startDate: moment().startOf("day"),
          endDate: moment().endOf("day"),
        });
        break;
      case "1week":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(7, "days").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(7, "days")
              .startOf("day"),
          });
        }
        break;
      case "1month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(1, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(1, "months")
              .startOf("day"),
          });
        }
        break;
      case "3month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(3, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(3, "months")
              .startOf("day"),
          });
        }
        break;
      case "6month":
        if (searchOptions.endDate === null || searchOptions.endDate === "") {
          setSearchOptions({
            ...searchOptions,
            startDate: moment().subtract(6, "months").startOf("day"),
            endDate: moment().endOf("day"),
          });
        } else {
          setSearchOptions({
            ...searchOptions,
            startDate: moment(searchOptions.endDate.format("YYYY/MM/DD"))
              .subtract(6, "months")
              .startOf("day"),
          });
        }
        break;
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setCurrentPageNumber(1);
    if (searchOptions.startDate === null || searchOptions.endDate === null) {
      alert("조회하려는 기간이 없습니다. 다시 설정해주시길 바랍니다.");
    } else {
      if (!searchOptions.startDate.isBefore(searchOptions.endDate)) {
        alert(
          "조회하려는 기간이 잘못 설정되어있습니다. 다시 시도해주시길 바랍니다.",
        );
      } else {
        getUserOrderList("search");
      }
    }
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      searchType: searchDateItems[0].searchType,
      searchStatus: orderStatusItems[1].value,
      searchOrderId: "",
      searchProductName: "",
      funnel: 0,
      name: "",
      phone: "",
      startDate: moment().subtract(7, "days").startOf("day"),
      endDate: moment().endOf("day"),
    });
    setDateType(dateTypeItems[1].value);
    setOffset(0);
    setPageSize(10);
    setSelectedRowKey([]);
    setSelectedRow([]);
    getUserOrderList("initial");
  };

  /**
   * 취소승인처리 handler
   */
  const handleCancelComplete = async () => {
    setIsLoading(true);
    try {
      if (selectedRow[0].use_point !== null) {
        const isLastOrderParam = {
          id: selectedRow[0].order_id,
          orderDetailIdList: selectedRowKey,
        };
        const isLastOrderRes = await salesManageApi.isLastOrderByOrderId(
          isLastOrderParam,
        );
        if (isLastOrderRes.result?.length !== 0) {
          throw `해당 주문은 포인트를 사용힌 주문이라 부분 환불이 불가합니다.\n선택한 주문번호와 동일한 모든 것들을 한번에 선택해서 다시 시도하거나 해당 주문번호와 함께 관리자에게 문의해주시길 바랍니다.`;
        }
      }
      if (
        window.confirm(
          `${selectedRow[0].order_id} - [${selectedRow[0].cancel_reason}] ${
            selectedRow[0].cancel_reason_detail
              ? selectedRow[0].cancel_reason_detail
              : ""
          } ${
            selectedRow?.length > 1 ? `외 ${selectedRow?.length - 1}건` : ""
          }  의 사유로 취소 요청된 주문입니다.\n해당 주문 건의 취소요청을 승인하시겠습니까?`,
        )
      ) {
        let cancelInfoList = [];
        let cancelCouponIdList = [];
        let totalPriceSum = 0;
        let cancelParam = {};
        let cancelPointParam = {};
        const sellerIdList = [
          ...new Set(selectedRow.map((row) => row.seller_id)),
        ];
        for (const sellerId of sellerIdList) {
          const orderBySeller = selectedRow.filter(
            (row) => row.seller_id === sellerId,
          );
          let isLastOrderParam = {
            seller_id: sellerId,
            id: orderBySeller[0].order_id,
            orderDetailIdList: orderBySeller.map(
              (order) => order.order_detail_id,
            ),
          };
          const isLastOrderRes = await salesManageApi.isLastOrder(
            isLastOrderParam,
          );
          console.log("isLastOrderRes", isLastOrderRes);
          if (isLastOrderRes.code !== 200) {
            throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`;
          }
          for (const order of orderBySeller) {
            totalPriceSum += order.total_price;
            if (order.coupon_id !== null && order.coupon_id !== "ADMIN") {
              cancelCouponIdList.push(order.coupon_id);
            }
            const cancelInfo = {
              order_id: order.order_id,
              order_detail_id: order.order_detail_id,
              order_detail_status: "cancel_complete",
              cancel_reason: order.cancel_reason,
              cancel_reason_detail: order.cancel_reason_detail,
              cancel_target: order.cancel_target,
              refund_holder:
                order.refund_holder === null ? "" : order.refund_holder,
              refund_bank: order.refund_bank === null ? "" : order.refund_bank,
              refund_account:
                order.refund_account === null ? "" : order.refund_account,
              updated_by: user.id === 724 ? 1 : user.id,
            };
            cancelInfoList.push(cancelInfo);
          }
          if (isLastOrderRes.result?.length === 0) {
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              totalPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum += orderBySeller[0].delivery_price;
            }
          } else {
            let remainPriceSum = 0;
            for (const order of isLastOrderRes.result) {
              remainPriceSum += order.total_price;
            }
            if (
              orderBySeller[0].delivery_price_baseline !== null &&
              remainPriceSum < orderBySeller[0].delivery_price_baseline
            ) {
              totalPriceSum -= orderBySeller[0].delivery_price;
            }
          }
        }
        // 포인트 환급
        if (selectedRow[0].use_point !== null) {
          console.log("마지막 주문입니다!!!", selectedRow[0]);
          cancelPointParam = {
            totalOrder: {
              id: selectedRow[0].order_id,
              order_status: "cancel_complete",
            },
          };
          totalPriceSum -= selectedRow[0].use_point;
        }
        if (selectedRow[0].pay_method === "vbank") {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
            cancel_request_amount: totalPriceSum,
            refund_holder: selectedRow[0].refund_holder,
            refund_bank: selectedRow[0].refund_bank,
            refund_account: selectedRow[0].refund_account,
            userOrderDetailList: selectedRow,
          };
        } else {
          cancelParam = {
            merchant_uid: selectedRow[0].order_id,
            imp_uid: selectedRow[0].imp_uid,
            reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
            cancel_request_amount: totalPriceSum,
            userOrderDetailList: selectedRow,
          };
        }
        console.log("cancelParam", cancelParam);
        const res = await salesManageApi.orderDirectlyCancel(cancelParam);
        if (res) {
          console.log("취소 승인처리 cancelCouponIdList", cancelCouponIdList);
          if (cancelCouponIdList?.length !== 0) {
            const cancelCoupon = {
              couponIdList: cancelCouponIdList,
              user_coupon_is_available: true,
              user_id: selectedRow[0].created_by,
              created_by: user.id === 724 ? 1 : user.id,
            };
            const cancelCouponRes = await promotionApi.userCouponChangeStatus(
              cancelCoupon,
            );
            console.log("취소 승인처리 cancelCoupon", cancelCouponRes);
            if (cancelCouponRes.code !== 200) {
              throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          // 포인트 환급
          if (Object.keys(cancelPointParam)?.length !== 0) {
            console.log("sdsadad", cancelPointParam);
            const cancelPointRes = await salesManageApi.purchasePointCancel(
              cancelPointParam,
            );
            console.log("포인트 환급 결과 ===", cancelPointRes);
            if (cancelPointRes.code !== 200) {
              throw `해당 주문건에서 사용한 포인트를 환급하는 과정에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
            }
          }
          for (const cancelInfo of cancelInfoList) {
            const cancelRes = await salesManageApi.orderCancelInfoEdit(
              cancelInfo,
            );
            if (cancelRes.code !== 200) {
              if (cancelRes.code === 999) {
                throw cancelRes.msg;
              } else {
                throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
              }
            }
          }
        } else {
          throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
        }
        alert("해당 내용이 성공적으로 반영되었습니다.");
        setSelectedRowKey([]);
        setSelectedRow([]);
        getUserOrderList();
      }
      setIsLoading(false);
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleCancelComplete error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };
  // const handleCancelComplete = async () => {
  //     setIsLoading(true)
  //     try {
  //         if (window.confirm(`${selectedRow[0].order_id} - [${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}  의 사유로 취소 요청된 주문입니다.\n해당 주문 건의 취소요청을 승인하시겠습니까?`)) {
  //             let cancelInfo = {}
  //             let cancelParam = {}
  //             let cancel_request_price = selectedRow[0].total_price
  //             let isLastOrderParam = {
  //                 seller_id: selectedRow[0].seller_id,
  //                 id: selectedRow[0].order_id,
  //                 orderDetailIdList: selectedRowKey
  //             }
  //             const isLastOrderRes = await salesManageApi.isLastOrder(isLastOrderParam)
  //             console.log("isLastOrderRes", isLastOrderRes)
  //             if (isLastOrderRes.code !== 200) {
  //                 throw `서버 오류로 해당 사항을 진행할 수 없습니다. 해당 오류가 계속해서 발생한다면 관리자에게 문의바랍니다.`
  //             }
  //             if (isLastOrderRes.result?.length === 0) {
  //                 if (selectedRow[0].delivery_price !== null && cancel_request_price < selectedRow[0].delivery_price_baseline) {
  //                     cancel_request_price += selectedRow[0].delivery_price
  //                 }
  //             } else {
  //                 let remainPriceSum = 0
  //                 for (const order of isLastOrderRes.result) {
  //                     remainPriceSum += order.total_price
  //                 }
  //                 if (selectedRow[0].delivery_price !== null && remainPriceSum < selectedRow[0].delivery_price_baseline) {
  //                     cancel_request_price -= selectedRow[0].delivery_price
  //                 }
  //             }
  //             if (selectedRow[0].pay_method === "vbank") {
  //                 cancelInfo = {
  //                     order_id: selectedRow[0].order_id,
  //                     order_detail_id: selectedRow[0].order_detail_id,
  //                     order_detail_status: "cancel_complete",
  //                     cancel_reason: selectedRow[0].cancel_reason,
  //                     cancel_reason_detail: selectedRow[0].cancel_reason_detail,
  //                     cancel_target: selectedRow[0].cancel_target,
  //                     refund_holder: selectedRow[0].refund_holder,
  //                     refund_bank: selectedRow[0].refund_bank,
  //                     refund_account: selectedRow[0].refund_account,
  //                     updated_by: user.id
  //                 }
  //                 cancelParam = {
  //                     merchant_uid: selectedRow[0].order_id,
  //                     imp_uid: selectedRow[0].imp_uid,
  //                     reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
  //                     cancel_request_amount: cancel_request_price,
  //                     refund_holder: selectedRow[0].refund_holder,
  //                     refund_bank: selectedRow[0].refund_bank,
  //                     refund_account: selectedRow[0].refund_account,
  //                     userOrderDetailList: selectedRow
  //                 }
  //             } else {
  //                 cancelInfo = {
  //                     order_id: selectedRow[0].order_id,
  //                     order_detail_id: selectedRow[0].order_detail_id,
  //                     order_detail_status: "cancel_complete",
  //                     cancel_reason: selectedRow[0].cancel_reason,
  //                     cancel_reason_detail: selectedRow[0].cancel_reason_detail,
  //                     cancel_target: selectedRow[0].cancel_target,
  //                     refund_holder: "",
  //                     refund_bank: "",
  //                     refund_account: "",
  //                     updated_by: user.id
  //                 }
  //                 cancelParam = {
  //                     merchant_uid: selectedRow[0].order_id,
  //                     imp_uid: selectedRow[0].imp_uid,
  //                     reason: `[${selectedRow[0].cancel_reason}] ${selectedRow[0].cancel_reason_detail}`,
  //                     cancel_request_amount: cancel_request_price,
  //                     userOrderDetailList: selectedRow
  //                 }
  //             }
  //             const res = await salesManageApi.orderDirectlyCancel(cancelParam)
  //             if (res) {
  //                 if (selectedRow[0].coupon_id !== null) {
  //                     const cancelCoupon = {
  //                         couponIdList: [selectedRow[0].coupon_id],
  //                         user_coupon_is_available: true,
  //                         user_id: selectedRow[0].created_by,
  //                         created_by: user.id
  //                     }
  //                     const cancelCouponRes = await promotionApi.userCouponChangeStatus(cancelCoupon)
  //                     if (cancelCouponRes.code !== 200) {
  //                         throw `해당 주문건에 대한 쿠폰 정보를 수정하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
  //                     }
  //                 }
  //                 const cancelRes = await salesManageApi.orderCancelInfoEdit(cancelInfo)
  //                 if (cancelRes.code !== 200) {
  //                     if (cancelRes.code === 999) {
  //                         throw res.msg
  //                     } else {
  //                         throw `해당 주문건에 대한 정보를 저장하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
  //                     }
  //                 }
  //             } else {
  //                 throw `해당 주문건을 환불하는데 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`
  //             }
  //             alert("해당 내용이 성공적으로 반영되었습니다.")
  //             setSelectedRowKey([])
  //             setSelectedRow([])
  //             getUserOrderList()
  //         }
  //         setIsLoading(false)
  //     } catch (e) {
  //         setIsLoading(false)
  //         setError(error)
  //         console.log('handleCancelComplete error', e)
  //         alert(e)
  //     } finally {
  //         setIsLoading(false)
  //     }
  // }

  /**
   * excel download
   */
  const handleExcelDownloadClick = () => {
    try {
      let excelData;
      if (totalOrderList?.length !== 0) {
        excelData = totalOrderList.map((row) => {
          return {
            order_id: row.order_id,
            order_detail_id: `dy${row.order_detail_id}`,
            payment_created_at: moment(row.payment_created_at).format(
              "YYYY.MM.DD HH:mm",
            ),
            order_detail_status:
              status.matchingOrderStatus[row.order_detail_status],
            product_id: row.product_id,
            product_name: row.product_name,
            option_id: row.option_id,
            option_title: row.option_title,
            quantity: row.quantity,
            total_price: row.total_price,
            price: row.price,
            coupon_discount_price: row.coupon_discount_price,
            created_by_name: row.created_by_name,
            use_point: row.use_point ? "Y" : "N",
            name: row.name,
            phone: row.phone,
            address:
              row.address +
              (row.address_detail ? `, ${row.address_detail}` : ""),
            address_request:
              row.address_request === "배송 시 요청사항을 선택해주세요."
                ? ""
                : row.address_request,
            delivery_company: status.matchingDeliveryCompany[
              row.delivery_company
            ]
              ? status.matchingDeliveryCompany[row.delivery_company]
              : row.delivery_company,
            tracking_number: row.tracking_number,
            ship_date: row.ship_date
              ? moment(row.ship_date).format("YYYY.MM.DD")
              : row.ship_date,
          };
        });
      } else {
        alert(
          "다운받으려는 데이터가 없습니다. 조회 후 다시 시도해주시길 바랍니다.",
        );
        throw "no data";
      }
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(excelData);
      Object.keys(excelData[0]).forEach((key, idx) => {
        const cellAdd = XLSX.utils.encode_cell({ c: idx, r: 0 });
        ws[cellAdd].v = status.matchingKey[key];
      });
      XLSX.utils.book_append_sheet(wb, ws, "주문취소관리");
      XLSX.writeFile(wb, `${moment().format("YYYYMMDD")}_주문취소관리.xlsx`);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("handleExcelDownloadClick edit error", error);
    }
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("payment_created_at");
        setOrderBy("desc");
      }
    }
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber) => {
    const currOffset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(currOffset);
  };

  /**
   * pageSize 변경 handler
   */
  const pageSizeChange = (current, pageSize) => {
    setPageSize(pageSize);
    setOffset((current - 1) * pageSize);
  };

  /**
   * 취소거부처리 Modal cancel handler
   */
  const handelCancelRefusalModalCancel = () => {
    setCancelRefusalReason({
      cancel_reason: "상품 배송중",
      cancel_reason_detail:
        "고객님, 취소요청하신 상품이 이미 발송되어, 상품 받으신 후에 반품 및 교환만 가능합니다.",
      delivery_company: null,
      tracking_number: "",
      ship_date: moment(),
    });
    setIsCancelRefusalModalOpen(false);
  };

  /**
   * 취소거부처리 Modal ok handler
   */
  const handleCancelRefusalModalOk = async () => {
    setIsLoading(true);
    try {
      const valid = handleCancelRefusalValidation();
      if (valid) {
        const orderList = selectedRow.map((row) => {
          return {
            ...row,
            ...cancelRefusalReason,
            order_detail_status: "delivery_shipping",
            cancel_target: "admin",
            ship_date:
              cancelRefusalReason.ship_date === null
                ? moment()
                : cancelRefusalReason.ship_date,
            updated_by: user.id === 724 ? 1 : user.id,
          };
        });
        let cancelParam = {
          preOrderDetailStatus: "cancel_request",
          userOrderDetailDTOList: orderList,
        };
        const res = await salesManageApi.orderTrackingNumRegister(cancelParam);
        const kakaoRes = await pushApi.kakaoForCancelRequestRefusal(orderList);
        if (kakaoRes.code !== 200) {
          getUserOrderList();
          setTimeout(() => {
            handelCancelRefusalModalCancel();
          }, 1000);
          throw `해당 주문건들에 대한 알림톡을 전송하는 부분에서 오류가 발생했습니다.\n관리자에게 문의하시길 바랍니다.`;
        }
        setTimeout(() => {
          handelCancelRefusalModalCancel();
        }, 1000);
        getUserOrderList();
        if (res.code === 200) {
          alert("해당 내용이 성공적으로 반영되었습니다.");
          // getUserOrderList()
        } else if (res.code === 999 || res.code === 405) {
          throw res.msg;
        } else {
          throw "해당 내용을 수정하는데 실패했습니다. 관리자에게 문의하시길 바랍니다.";
        }
      } else {
        throw "필수값이 채워지지 않았습니다. 다시 시도해주시길 바랍니다.";
      }
    } catch (e) {
      setIsLoading(false);
      setError(error);
      console.log("handleCancelRefusal error", e);
      alert(e);
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * 취소거부처리 validation
   */
  const handleCancelRefusalValidation = () => {
    if (
      cancelRefusalReason.hasOwnProperty("cancel_reason") &&
      cancelRefusalReason.cancel_reason !== null &&
      cancelRefusalReason.cancel_reason !== "" &&
      cancelRefusalReason.hasOwnProperty("delivery_company") &&
      cancelRefusalReason.delivery_company !== null &&
      cancelRefusalReason.delivery_company !== "" &&
      cancelRefusalReason.hasOwnProperty("tracking_number") &&
      cancelRefusalReason.tracking_number !== null &&
      cancelRefusalReason.tracking_number !== ""
    ) {
      return true;
    } else {
      return false;
    }
  };

  const disabledCancelComplete = () => {
    if (selectedRow?.length === 0) {
      return true;
    } else {
      let orderId = 0;
      let validList = [];
      for (let i = 0; i < selectedRow?.length; i++) {
        const row = selectedRow[i];
        if (i === 0) {
          orderId = row.order_id;
          if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
            validList.push(false);
          } else {
            if (
              row.order_detail_status === "cancel_request" &&
              row.cancel_target !== "admin"
            ) {
              validList.push(true);
            } else {
              validList.push(false);
            }
          }
        } else {
          if (row.order_id !== orderId) {
            validList.push(false);
          } else {
            if (row.hasOwnProperty("is_deposit") && row.is_deposit) {
              validList.push(false);
            } else {
              if (
                row.order_detail_status === "cancel_request" &&
                row.cancel_target !== "admin"
              ) {
                validList.push(true);
              } else {
                validList.push(false);
              }
            }
          }
        }
      }
      return !validList.every((result) => result);
    }
    // if (selectedRow?.length === 0) {
    //     return true
    // } else {
    //     return !(selectedRow[0].order_detail_status === "cancel_request" && selectedRow[0].cancel_target !== "admin")
    // }
  };

  return (
    <>
      <ContentHeaderComponent title="취소관리" />
      <div className="product-register-wrap">
        {/*취소현황상태*/}
        <Row className="product-search-product-status-wrap">
          {/*취소요청*/}
          <Col span={12} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/cancel_request_icon.png`}
              />
              <div className="product-status-text">
                <div>취소요청</div>
                <div>
                  <span className="product-status-num">
                    {cancelStatus.cancelRequest}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>

          {/*취소완료*/}
          <Col span={12} md={5}>
            <Row className="product-status-box-wrap">
              <img
                className="product-status-icon"
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/cancel_complete_icon.png`}
              />
              <div className="product-status-text">
                <div>취소완료(최근 3일)</div>
                <div>
                  <span className="product-status-num">
                    {cancelStatus.cancelComplete}
                  </span>{" "}
                  건
                </div>
              </div>
            </Row>
          </Col>
        </Row>

        {/*취소현황검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="조회기간"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchType}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchType: value })
              }
              style={{ width: 120, textAlign: "left" }}
            >
              {searchDateItems.map((item, idx) => (
                <Option
                  key={`order_date_search_${idx}`}
                  value={item.searchType}
                >
                  {item.searchText}
                </Option>
              ))}
            </Select>
            <Row align={"middle"} style={{ marginTop: 10, gap: "5px" }}>
              <Radio.Group
                className={`options-list`}
                options={dateTypeItems}
                onChange={handleDateTypeChange}
                value={dateType}
                optionType="button"
              />
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.startDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, startDate: value });
                }}
              />
              ~
              <DatePicker
                className="order-search-date-wrap"
                format="YYYY/MM/DD"
                value={searchOptions.endDate}
                onChange={(value) => {
                  setDateType("");
                  setSearchOptions({ ...searchOptions, endDate: value });
                }}
              />
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="주문상태"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Select
              value={searchOptions.searchStatus}
              onChange={(value) =>
                setSearchOptions({ ...searchOptions, searchStatus: value })
              }
              style={{ width: 250, textAlign: "left" }}
            >
              {orderStatusItems.map((item, idx) => (
                <Option key={`order_status_search_${idx}`} value={item.value}>
                  {item.label}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          {/*<Form.Item*/}
          {/*    className="center-label"*/}
          {/*    label="유입경로"*/}
          {/*    labelAlign="left"*/}
          {/*    colon={false}*/}
          {/*    labelCol={{span: 3}}*/}
          {/*    wrapperCol={{span: 21}}*/}
          {/*>*/}
          {/*    <Radio.Group options={funnelStatusItems} onChange={(e) => setSearchOptions({ ...searchOptions, funnel: e.target.value })} value={searchOptions.funnel} />*/}
          {/*</Form.Item>*/}
          {/*<Divider className="product-register-form-input-divider"/>*/}
          <Form.Item
            label="상세검색"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle">
              <Col sm={5} md={2}>
                <div className="content-search-wrap">주문번호</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchOrderId"
                  value={searchOptions.searchOrderId}
                  onChange={(e) => {
                    const reg = /^[0-9]*$/;
                    if (reg.test(e.target.value) || e.target.value === "") {
                      setSearchOptions({
                        ...searchOptions,
                        [e.target.name]: e.target.value,
                      });
                    }
                  }}
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">상품명</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="searchProductName"
                  value={searchOptions.searchProductName}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
            <Row align="middle" style={{ marginTop: 10 }}>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">이름</div>
              </Col>
              <Col style={{ marginRight: "2rem" }}>
                <Input
                  name="name"
                  value={searchOptions.name}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
              <Col sm={5} md={2}>
                <div className="content-search-wrap">연락처</div>
              </Col>
              <Col>
                <Input
                  name="phone"
                  value={searchOptions.phone}
                  onChange={(e) =>
                    setSearchOptions({
                      ...searchOptions,
                      [e.target.name]: e.target.value,
                    })
                  }
                  style={{ width: 150, textAlign: "left" }}
                  onPressEnter={handleSearch}
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="product-search-button-wrap" justify="center">
            <Button
              className="product-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="product-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*취소목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20, borderBottom: 0 }}
        >
          <div>
            <span className="product-register-box-title">
              주문목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          <div>
            <Button
              className="order-excel-download-btn"
              icon={
                <img
                  style={{ height: 14.2, width: 14.5, marginRight: 5 }}
                  src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`}
                />
              }
              onClick={handleExcelDownloadClick}
            >
              엑셀다운
            </Button>
          </div>
        </Row>
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
        >
          <div>
            <Button
              className="order-status-change-button"
              disabled={disabledCancelComplete()}
              onClick={() => handleCancelComplete()}
            >
              취소 승인처리
            </Button>
          </div>
          <div>
            <Button className="order-status-change-button" disabled>
              구매확정 후 취소처리 바로가기
              <img
                style={{ height: 14.2, width: 14.5 }}
                src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/Icon.png`}
              />
            </Button>
          </div>
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            borderBottom: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            rowSelection={rowSelection}
            columns={columns}
            dataSource={orderList}
            loading={isLoading}
            bordered
            size="middle"
            rowKey="order_detail_id"
            rowClassName="coupon-table-row"
            // scroll={{x: 'calc(700px + 50%)'}}
            scroll={{ x: "max-content" }}
            tableLayout={"auto"}
            onChange={tableOnChange}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showSizeChanger
              pageSize={pageSize}
              onShowSizeChange={pageSizeChange}
              total={totalSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
        <div
          className="product-register-border-box"
          style={{
            backgroundColor: "#f8f9fd",
            height: "fit-content",
            padding: "15px 25px",
          }}
        >
          <Form.Item
            className="order-bottom-form-item center-label"
            label="취소"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row>
              <Button
                className="order-status-change-button"
                disabled={disabledCancelComplete()}
                onClick={() => handleCancelComplete()}
              >
                취소 승인처리
              </Button>
              <Button
                className="order-status-change-button"
                disabled={disabledCancelComplete()}
                onClick={() => setIsCancelRefusalModalOpen(true)}
              >
                취소 거부처리
              </Button>
            </Row>
          </Form.Item>
        </div>

        {/*취소 거부처리 Modal*/}
        {isCancelRefusalModalOpen && (
          <Modal
            title="취소 거부처리"
            visible={isCancelRefusalModalOpen}
            onCancel={handelCancelRefusalModalCancel}
            onOk={handleCancelRefusalModalOk}
            cancelText={<span>닫기</span>}
            okText={<span>확인</span>}
            confirmLoading={isLoading}
            width={"50%"}
          >
            <Form.Item
              label="취소 불가 사유"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="cancel_reason"
                value={cancelRefusalReason.cancel_reason}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value,
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="구매자에게 전하실 말씀"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <Input.TextArea
                className="order-modal-address-request-wrap"
                name="cancel_reason_detail"
                value={cancelRefusalReason.cancel_reason_detail}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value,
                  })
                }
                rows={5}
              />
            </Form.Item>
            <Form.Item
              label="택배사"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Select
                className="order-delivery-company-select"
                placeholder="선택"
                value={cancelRefusalReason.delivery_company}
                onChange={(value, e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.id]: value,
                  })
                }
              >
                {deliveryCompanyList.map((deliveryCompany, idx) => (
                  <Option
                    key={`delivery_company_select_${idx}`}
                    id="delivery_company"
                    value={deliveryCompany.delivery_company_id}
                  >
                    {deliveryCompany.delivery_company_name}
                  </Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item
              label="송장번호"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
              required
            >
              <Input
                name="tracking_number"
                value={cancelRefusalReason.tracking_number}
                onChange={(e) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    [e.target.name]: e.target.value.trim(),
                  })
                }
              />
            </Form.Item>
            <Form.Item
              label="발송일"
              labelAlign="left"
              colon={false}
              labelCol={{ span: 6 }}
              wrapperCol={{ span: 18 }}
            >
              <DatePicker
                className="order-ship-date-input"
                format="YYYY-MM-DD"
                value={cancelRefusalReason.ship_date}
                onChange={(value) =>
                  setCancelRefusalReason({
                    ...cancelRefusalReason,
                    ship_date: value,
                  })
                }
              />
            </Form.Item>
          </Modal>
        )}
      </div>
    </>
  );
};

export default CancelManageComponent;
